import React from 'react';
import { Modal } from '../../ui-library/molecules/modals';

const NewsletterSubscriptionModal = ({ isOpen, onHide }) => {
  const styleOverrides = {
    header: { padding: '32px 0 0 0' },
    title: { marginBottom: '0' },
    content: { height: '620px', padding: 0 },
  };
  return (
    <Modal
      isOpen={isOpen}
      onHide={onHide}
      title='Join our Newsletter'
      styleOverrides={styleOverrides}
    >
      <iframe
        id='sibform_iframe'
        width='540'
        height='620'
        src='https://628dbd94.sibforms.com/serve/MUIEACHpq9ty-6xooO9I3VAUuu33BCVGimAeA6qS_r7HTpBI77jEFnEEsxCpqtFxmb0-QaVkfOmrkSe7LmRWHM_3b7LGUb0Klz-GDXuWvSx9PcX0sUapWzjEliMFJ6253SHD6I9XcNXYBh3lpv_r7hbievtfa-jKBlZ6sEKZgVeHxv5S-VB-VdtxbgbrnbosFppdxe56W3MVKYmC'
        frameBorder='0'
        scrolling='auto'
        allowFullScreen
        style={{
          display: 'block',
          margin: '0 auto',
          maxWidth: '100%',
          padding: 0,
        }}
      ></iframe>
    </Modal>
  );
};

export default NewsletterSubscriptionModal;
